var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "407.000000pt",
    height: "407.000000pt",
    viewBox: "0 0 407.000000 407.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,407.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485 3673 c4 -219 10 -477 14 -573 l6 -175 465 -81 c256 -44 468 -79 473 -77 10 6 9 1161 -2 1167 -20 13 -836 136 -897 136 l-66 0 7 -397z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610 3327 c0 -322 4 -588 8 -591 16 -10 835 -147 848 -142 12 4 14 106 14 583 0 318 -4 583 -8 589 -4 6 -185 39 -402 73 -217 34 -410 64 -427 68 l-33 5 0 -585z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2644 3737 c-2 -7 -3 -275 -2 -597 l3 -584 215 -37 c118 -21 332 -57 474 -82 l259 -45 -6 596 c-3 327 -9 598 -14 603 -5 5 -207 40 -448 79 -242 38 -448 72 -458 74 -10 3 -20 -1 -23 -7z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 2200 l0 -560 23 -5 c12 -2 218 -36 457 -75 239 -39 443 -74 453 -76 16 -5 17 26 17 551 0 435 -3 557 -12 560 -7 3 -211 38 -453 80 -242 41 -450 77 -462 80 l-23 5 0 -560z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 2418 c4 -79 7 -328 7 -553 l0 -411 415 -68 c228 -38 421 -66 430 -63 13 6 15 69 15 546 0 338 -4 542 -10 546 -12 7 -807 145 -839 145 l-24 0 6 -142z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2642 1839 l3 -554 435 -71 c239 -40 452 -75 473 -78 l37 -6 0 548 0 548 -457 79 c-251 43 -465 80 -475 83 -17 4 -18 -17 -16 -549z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 993 l3 -478 35 -3 c32 -3 532 -87 784 -132 60 -11 113 -20 118 -20 4 0 7 215 6 478 l-3 477 -430 72 c-236 39 -449 74 -473 78 l-42 6 2 -478z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620 809 l0 -479 23 -5 c12 -3 191 -35 397 -70 206 -36 387 -68 403 -71 l27 -6 0 485 0 484 -407 67 c-225 36 -416 68 -425 70 -17 4 -18 -24 -18 -475z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 637 l0 -485 28 -6 c150 -32 795 -140 856 -143 l78 -5 -7 478 c-4 264 -10 482 -14 485 -3 3 -206 38 -451 78 -245 40 -455 75 -467 78 l-23 5 0 -485z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/Layout.d42f6c05032350499a6f84b9456845fa.svg";
export { ForwardRef as ReactComponent };